"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyCardSaveButtonMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _ButtonIcon = require("../../components/ButtonIcon/ButtonIcon.styles");
var _constants = require("../../constants");
var _spaceMixin = require("../spaceMixin");
/** @class PropertyCardSaveButtonMixin */
/** @method */
var PropertyCardSaveButtonMixin = function PropertyCardSaveButtonMixin(props) {
  return (0, _styledToken.default)({
    iconColors: ["Button." + _constants.BUTTON_TYPES.secondary + "Inverse"],
    iconFill: 'PropertyCard.saveButton.icon.fill.default',
    iconFillHover: 'PropertyCard.saveButton.icon.fill.hover',
    iconShadow: 'PropertyCard.saveButton.icon.shadow',
    iconSize: 'PropertyCard.saveButton.icon.size',
    saveButtonBorder: 'PropertyCard.saveButton.border',
    saveButtonPadding: ['PropertyCard.saveButton.padding']
  }, function (_ref) {
    var iconColors = _ref.iconColors,
      iconFill = _ref.iconFill,
      iconFillHover = _ref.iconFillHover,
      iconShadow = _ref.iconShadow,
      iconSize = _ref.iconSize,
      saveButtonBorder = _ref.saveButtonBorder,
      saveButtonPadding = _ref.saveButtonPadding;
    return (0, _styledComponents.css)(["&&&{background-color:transparent;border:", ";padding:", ";}", "{filter:drop-shadow(", ");height:", "px;margin-right:0;width:", "px;.HeartIcon__outline{fill:", ";}.HeartIcon__fill{fill:", ";}}&:hover,&:active,&:focus{.HeartIcon__fill{fill:", ";}}&[aria-pressed='true'],&[aria-label='Unsave']{.HeartIcon__fill{fill:", ";}}"], saveButtonBorder, saveButtonPadding ? saveButtonPadding.top + "px " + saveButtonPadding.right + "px " + saveButtonPadding.bottom + "px " + saveButtonPadding.left + "px" : (0, _spaceMixin.spaceMixin)('xs')(props) + " " + (0, _spaceMixin.spaceMixin)('xs')(props) + "\n                        " + (0, _spaceMixin.spaceMixin)('sm')(props) + " " + (0, _spaceMixin.spaceMixin)('sm')(props), _ButtonIcon.StyledButtonIcon, iconShadow, iconSize, iconSize, iconColors.fontColor, iconFill, iconFillHover, iconColors.fontColor);
  })(props);
};
exports.PropertyCardSaveButtonMixin = PropertyCardSaveButtonMixin;